import React from 'react';
import { Link } from 'react-router-dom';

import bubble1 from '../../content/images/bubble-1.png';
import bubble2 from '../../content/images/bubble-2.png';
import bubble3 from '../../content/images/bubble-3.png';
import grade_graph from '../../content/images/grade-graph.png';
import dgl_ipad from '../../content/images/dgl-ipad.png';
import dgl_laptop from '../../content/images/dgl-laptop.png';
import happy_certificate from '../../content/images/happy-certificate.jpg';

function TheProgram() {

    return (
        <React.Fragment>
            <link rel="stylesheet" type="text/css" href="/styles/about.css" />
            
            <div class="about-title-image">
                <h1 class="about-title-main remove-underline">The Program</h1>
                <div class="row" style={{ "padding-bottom": "20px"}}>
                    <div class="col-md-4 large-right">
                        <a href="#whositfor" class="link-button">Who's it For</a>
                    </div>
                    <div class="col-md-4" style={{ "padding": "0px" }}>
                        <a href="#resultsandbenefits" class="link-button">Results & Benefits</a>
                    </div>
                    <div class="col-md-4 large-left">
                        <a href="#howitworks" class="link-button">How it Works</a>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-2"></div>
                    <div class="col-md-4">
                        <a href="#keyfeatures" class="link-button">Key Features</a>
                    </div>
                    <div class="col-md-4">
                        <a href="#whyitmatters" class="link-button">Why it Matters</a>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>

            <span class="anchor" id="whositfor"></span>
            <div class="content-section-g" id="whositfor">
                <div class="row">
                    <div class="col-md-6 vcenter">
                        <h2 class="section-title">Who's it For</h2>
                        <ul class="text-left big-section">
                            <li>K-12 Students reading below the 5th grade level</li>
                            <li>Dyslexia, ADHD, and other common learning disabilities</li>
                            <li>Students lacking phonics, comprehension, or fluency</li>
                            <li>Districts, Schools, Learning Centers & Tutors, or Parents</li>
                        </ul>
                        <Link to='/about/use-cases' class="link-button-body">Use Cases <span class="glyphicon glyphicon-chevron-right arrow-icon"></span></Link>
                    </div>
                    <div class="col-md-6 vcenter">
                        <img src={happy_certificate} width="100%" />
                    </div>
                </div>
            </div>

            <span class="anchor" id="resultsandbenefits"></span>
            <div class="content-section-w" id="resultsandbenefits">
                <div class="row">
                    <div class="col-md-4 vcenter">
                        <img src={grade_graph} width="100%" />
                    </div>
                    <div class="col-md-8 vcenter" style={{ "padding-left": "40px", "padding-right": "50px" }}>
                        <h2 class="section-title">Results & Benefits</h2>
                        <div class="text-left">
                            <p><strong>Fluent, independent reading</strong> that generalizes to benefit students in their classwork and outside lives.</p>
                            <p><strong>Improves student motivation</strong>, behavior and work in other classes as their academic self-confidence builds.</p>
                            <p><strong>Teaches comprehension</strong> and expressive language through Depth of Knowledge questions relating to the stories.</p>
                            <p><strong>Increased fidelity</strong> comes from the digital data allowing administrators to view student performance, identify outliers, and hold instructors accountable.</p>
                        </div>
                        <Link to='/about/testimonials' class="link-button-body">What Our Customers Say <span class="glyphicon glyphicon-chevron-right arrow-icon"></span></Link>
                    </div>
                </div>
            </div>

            <span class="anchor" id="howitworks"></span>
            <div id="howitworks-container">
                <h2 class="section-title-left">How it Works</h2>
                <div class="row">
                    <div class="col-md-4">
                        <div class="row text-left">
                            <img src={bubble1} class="num-bubble" height="60px" width="60px" />
                            <h4 class="box-title">Made for Students</h4>
                        </div>
                        <div class="row">
                            <ul class="text-left">
                                <li>Fun stories keep students engaged and motivated</li>
                                <li>Positive reinforcement builds confidence</li>
                                <li>15-minute sessions stay within the student’s attention span</li>
                                <li>Goal oriented nature of the program challenges and motivates students</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row text-left">
                            <img src={bubble2} class="num-bubble" height="60px" width="60px" />
                            <h4 class="box-title">Daily Practice</h4>
                        </div>
                        <div class="row">
                            <ul class="text-left">
                                <li>15 minutes/day 3-5 days per week yields impressive growth</li>
                                <li>Students work in phonics, sight phrases and stories with comprehension questions each session</li>
                                <li>Consistent daily practice brings the best results</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="row text-left">
                            <img src={bubble3} class="num-bubble" height="60px" width="60px" />
                            <h4 class="box-title">1-on-1 Instruction</h4>
                        </div>
                        <div class="row">
                            <ul class="text-left">
                                <li>Immediate correction by an instructor quickly eliminates errors</li>
                                <li>Modeling also eliminates errors while building speed and proper intonation</li>
                                <li>Constant positive reinforcement builds trust, motivation and self confidence</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <span class="anchor" id="keyfeatures"></span>
            <div class="content-section-w" id="keyfeatures-container">
                <div class="row">
                    <h2 class="section-title-left">Key Features</h2>
                </div>
                <div class="text-left">
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <p><strong>Automatic Charting</strong> ensures that student data is kept accurately, shows clear results and makes our program even easier to use than before.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <p><strong>Cross-Platform Capability</strong> means that you can access the program from any internet connected devices such as computers, tablets, or phones.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <p><strong>Student/Teacher Connectivity</strong> links together two separate devices, allowing the teacher full access to all features while the students see only the exercises they are working on. This also allows for doing Great Leaps at a distance.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 col-md-12">
                            <p><strong>Student Sharing</strong> allows teachers and administrators to delegate varying levels of student access between accounts. Schools can also allow parents to work with students over the summer which is not possible with physical books.</p>
                        </div>
                    </div>
                    <div id="device-img-row" class="row">
                        <div id="laptop-img" class="col-md-8">
                            <img src={dgl_laptop} />
                        </div>
                        <div id="ipad-img" class="col-md-4">
                            <img src={dgl_ipad} />
                        </div>
                    </div>
                </div>
            </div>

            <div id="whyitmatters-container">
                <div id="overlay-title">
                    <span class="anchor" id="whyitmatters"></span>
                    <h2 id="overlay-text">Why it Matters</h2>
                    <div id="overlay-box-container" class="row equal">
                        <div class="col-sm-6 col-md-3">
                            <div class="col-md-12 box">
                                <h1>90%+</h1>
                                <p>Students with reading troubles can be taught with early intervention</p>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <div class="col-md-12 box">
                                <h1>85%</h1>
                                <p>Juveniles in the court system are illiterate</p>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <div class="col-md-12 box">
                                <h1>66%</h1>
                                <p>Students who can't read by 4th grade end up in jail or on welfare</p>
                            </div>
                        </div>
                        <div class="col-sm-6 col-md-3">
                            <div class="col-md-12 box">
                                <h1>4X</h1>
                                <p>3rd graders who can't read are 4x more likely to drop out later in school</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default TheProgram;
